import { ThemeDefinition } from "@hackthenorth/north";
import { css } from "styled-components";

import { textSharedStyles, textModifiers } from "./text";

export const linkSharedStyles = css`
  ${textSharedStyles}
  color: ${({ theme }) => theme.globalConstants.color.brandPrimary};
  display: inline-block;
  text-decoration: underline;
  font-weight: 800;

  &:hover,
  &:focus {
    opacity: 80%;
  }
`;

export const linkStyles: ThemeDefinition["link"] = {
  sharedStyles: linkSharedStyles,
  modifiers: {
    ...textModifiers,
    "no-decoration": css`
      text-decoration: none;
    `,
  },
};
